module.exports = __webpack_public_path__ + "static/media/bike.2d037798.svg";